<template>
  <div class="d-flex flex-wrap">
    <template v-for="(m, index) in mopList">
      <mop-item
        @edit="
          () =>
            $router.push({
              name: 'MainModeForm',
              params: { mopId: m.mopId, mode: 'edit' },
            })
        "
        @delete="deactivate(m)"
        @toggleStatus="toggleStatus(m)"
        v-bind:mop="m"
        v-bind:key="index"
      />
    </template>
  </div>
</template>

<script>
import MopItem from "@/views/pages/mode-of-payment/MopItem.vue";
import { layoutMethods, mopMethods, mopComputed } from "@/state/helpers";
import Swal from "sweetalert2";
import _ from 'lodash';
import { getModuleAccess, showAccessRestrictedModal } from '@/router/helper.js';

export default {
  data(){
    return {
      mopList: [],
      unlockReason: [
        "Completed Maintenance",
        "Resolved Bugs/Issue",
        "Resolved Fraud Investigation",
      ],
      lockReason: [
        "Maintenance",
        "Bugs/Issue",
        "Change in Business Strategy",
        "Fraud Investigation"
      ],
      modesOfPaymentModule: {
				access: {
					create: false,
          read: false,
          update: false,
          delete: false
				}
			}
    }
  },
  components: {
    MopItem,
  },
  computed: {
    ...mopComputed,
  },
  methods: {
    ...layoutMethods,
    ...mopMethods,
    endHtml(status){
      var reasons = [];
      var statustxt = 'enable';
      if(status == 'a'){
        reasons = this.unlockReason;
      } else if(status == 'i'){
        reasons = this.lockReason;
        statustxt = 'disable';
      }
      var titleDiv = `<div class="mb-4">This will ${statustxt} this payment mode in all modules.</div>`;
      var selectOne = '<select id="mop-remarks" class="form-control" >'
      selectOne += '<option value="" disabled selected>Select reason</option>'
      reasons.forEach(r => {
        selectOne += `<option value="${r}">${r}</option>`
      });
      selectOne += "</select>";
      var divOne = '<div class="mb-4">'+selectOne+'</div>';

      var html = `<div>${titleDiv}${divOne}</div>`
      return html;
    },
    deleteHtml(mopName = ''){
      var titleDiv = `<div class="mb-4">Are you sure you want to delete this ${mopName} top-up mode of payment?<br/>This process cannot be undone</div><div class="mb-4">Please provide a reason for the deletion:</div>`;
      var inputOne = `<label class="w-100 text-start form-label small fw-bold">Reason<span class="text-danger">*</span></label><input maxlength="50" id="mop-delete-remarks" placeholder="Enter reason" class="form-control" ><div class="character-count text-end mt-2"><span id="mod-character-count">0</span>/50</div>`
      var divOne = '<div class="mb-4">'+inputOne+'</div>';

      var html = `<div>${titleDiv}${divOne}</div>`
      return html;
    },
    deactivate(mop) {
      if (this.modesOfPaymentModule.access.delete) {
        Swal.fire({
          title: "Are you sure?",
          text: `Do you really want to delete ${mop.displayName} top-up mode of payment? This process cannot be undone.`,
          html: this.deleteHtml(mop.displayName),
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#6E66D9",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Confirm",
          cancelButtonText: "No",
          preConfirm: function(){
            if(!document.getElementById('mop-delete-remarks').value){
              Swal.showValidationMessage("Please input reason");  
            }
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteMop({
              mopId: mop.mopId, 
              reason: document.getElementById('mop-delete-remarks').value
            })
              .then(() => {
                Swal.fire(
                  "Mode of Payment Delete Successful!",
                  `${mop.displayName} has been successfully deleted.`,
                  "success"
                );
                this.listMop();
              })
              .catch((e) => {
                Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "error");
              });
          } else {
            return;
          }
        });
           
        document.getElementById('mop-delete-remarks').addEventListener('input', function (){
          var length = document.getElementById('mop-delete-remarks').value.length;
          document.getElementById('mod-character-count').innerHTML = length;
        });
        
      } else {
        showAccessRestrictedModal();
      }
    },
    toggleStatus: function(m){
      var oldStatus = m.status == 'a' ? 'i' : 'a';
      Swal.fire({
          title: 'Are you sure?',
          html: this.endHtml(m.status),
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '##804997',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          preConfirm: function(){
            if(!document.getElementById('mop-remarks').value){
              Swal.showValidationMessage("Please select reason");  
            }
          }
      }).then((result) => {
          if (result.isConfirmed) {
            this.updateMopStatus({
              mopId: m.mopId,
              status: m.status == 'a',
              reason: document.getElementById('mop-remarks').value
            })
              .then(() => {
                Swal.fire(
                  "Update Successful!",
                  `MOP was updated`,
                  "success"
                );
              })
              .catch(err => {
                m.status = oldStatus;
                Swal.fire(
                  "Update Failed!",
                  err.message? err.message : `MOP was not updated.`,
                  "error"
                );
              });
          } else{
            m.status = oldStatus;
          }
      })
    }
  },
  async mounted() {
    this.listMop().then(() => {
      this.mopList = _.cloneDeep(this.mops)
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'Modes of Payment')
      .then((access) => this.modesOfPaymentModule.access = access);

  }
};
</script>

<style>
.character-count {
  font-size: 12px; 
}
</style>